import { AssetTypeAttachmentService as OvermapAssetTypeAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetTypeAttachmentService extends OvermapAssetTypeAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
